<template>
  <span>
    <ArrowNav
      v-if="showLeft"
      type="left"
      @on-click="onClickLeft(true)"
    />
    <ArrowNav
      v-if="showRight"
      type="right"
      @on-click="onClickRight(false)"
    />
  </span>
</template>

<script>
import ArrowNav from './arrow-nav';
export default {
  name: "ArrowsNav",

  props: {
    showLeft: {
      type: Boolean,
      require: false,
      default: true,
    },
    showRight: {
      type: Boolean,
      require: false,
      default: true,
    },
  },

  components: {
    ArrowNav
  },

  methods: {
    onClickLeft: function () {
      this.$emit("on-click-left");
    },
    onClickRight: function () {
      this.$emit("on-click-right");
    },
  },
};
</script>